import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService } from './auth.service';

export const authGuard: CanActivateFn = (_route, state) => {
  const authService = inject(AuthService);

  if (!authService.isLoggedIn) {
    // Pass the requested URL so AuthService can stash it (in sessionStorage)
    // and restore it after the OAuth redirect lands back at the bare origin.
    authService.login(state.url);
    return false;
  }

  // EB-3775 — belt-and-braces: app.html @switch already hides the shell, but
  // a feature route placed outside the gate would still bypass it without this.
  if (authService.accessState() !== 'authorized') return false;

  // CR-11: ensureUserDetailsLoaded() removed — evaluateAccess() in
  // configure() already populates userDetails$ for every authorized user.
  return true;
};
